import React, { useState, useEffect } from "react";
import useRenewalFlow, {
  RENEW_POLICY_LOGGED_IN,
  RENEW_POLICY_LOGGED_OUT,
} from "../../../../hooks/useRenewalFlow";
import RenewMotorLayout from "../renewMotorLayout";
import useValidation from "../../../../hooks/useValidation";
import TitleDescription from "../../../../components/newMotorPolicy/titleDescription/titleDescription";
import { useTranslation } from "react-i18next";
import useMotorForm from "../../../../hooks/useMotorFormData";
import Input from "../../../../components/common/Input/Input";
import { useDispatch, useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { toast } from "sonner";
import { selectLoginTokenInfo } from "../../../../redux/features/loginRegisterSlice";
import { fetchUserPolicies } from "../../../../redux/features/myPolicySlice";
import { motorRenewalPremium } from "../../../../redux/features/motor/renewalPremiumSlice";
import { clearApplyPromoState } from "../../../../redux/features/promoCode/promoCodeSlice";
import { PROMO_CODE } from "../../../../components/newMotorPolicy/veiwSummaryPopup/viewSummaryPopup";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import { getClientSource } from "../../../../utils/getClientSource";
import { sendLoginOtp } from "../../../../redux/features/account/accountOtpSlice";

export const RENEW_POLICY_CPR_PLATE_NUMBER = "RENEW_POLICY_CPR_PLATE_NUMBER";

const CprPlateNumberPage = () => {
  const dispatch = useDispatch();
  const loginTokenInfo = useSelector(selectLoginTokenInfo);
  const isLoggedin = loginTokenInfo;

  const { handleFlowChange } = useRenewalFlow();
  const { errors, validateFields } = useValidation();
  const { t } = useTranslation();
  const translate = useLanguageTranslate();

  const [formData, setFormData] = useState({ cprNumber: "", plateNumber: "" });
  const [isLoading, setIsLoading] = useState(false);

  const { removeMotorFormData } = useMotorForm(
    RENEW_POLICY_CPR_PLATE_NUMBER,
    setFormData
  );
  const { removeMotorFormPromoCodeData } = useMotorForm(
    PROMO_CODE,
    setFormData
  );

  const validateForm = (data) => {
    let validationConfig = [
      { name: "cprNumber", validations: ["required"] },
      { name: "plateNumber", validations: ["required"] },
    ];
    let isFormValid = validateFields(validationConfig, data ? data : formData);
    console.log("validation result ", isFormValid);

    return isFormValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    removeMotorFormData();
    const updated = { ...formData, [name]: value };
    setFormData(updated);
    validateForm(updated);
  };

  useEffect(() => {
    if (isLoggedin) {
      handleFlowChange(RENEW_POLICY_LOGGED_IN, 0, 0);
    } else {
      handleFlowChange(RENEW_POLICY_LOGGED_OUT, 0, 0);
    }
  }, [isLoggedin]);

  const { saveMotorDataInRedux } = useMotorForm(
    RENEW_POLICY_CPR_PLATE_NUMBER,
    setFormData
  );

  const continueClickHanlder = async () => {
    console.log("✅ Button clicked");

    if (!validateForm()) return;

    setIsLoading(true);
    try {
      const sendOtpPayload = {
        CPR: formData.cprNumber,
      };

      const sendOtpAction = await dispatch(sendLoginOtp(sendOtpPayload));
      const sendOtpResult = unwrapResult(sendOtpAction);

      if (sendOtpResult) {
        const updatedFormData = {
          ...formData,
          pinId: sendOtpResult.pinId,
          phone: sendOtpResult.phoneNumber,
        };
        saveMotorDataInRedux(updatedFormData);
        handleFlowChange(RENEW_POLICY_LOGGED_OUT, 1);
      }
    } catch (error) {
      const errorMessage = error?.ErrorMessageEn || "Failed to send OTP";
      toast.error(translate(errorMessage, error?.ErrorMessageAr || errorMessage));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <RenewMotorLayout
      show_close_btn
      is_hide_back_btn={true}
      btn_onClick={continueClickHanlder}
      passedFrom="MotorRenewal"
    >
      <div className="max-w-[100%] w-[500px] mx-auto bg-white max767:p-5 ">
        <TitleDescription
          title={t("motorInsurance.renewalPolicyFlow.cprNoPage.quickRenewal")}
          description={t(
            "motorInsurance.renewalPolicyFlow.cprNoPage.quickRenewalDesc"
          )}
        />
        <Input
          name="cprNumber"
          type="text"
          label={t("motorInsurance.renewalPolicyFlow.cprNoPage.cprNo")}
          value={formData?.cprNumber}
          error={errors?.cprNumber}
          handleChange={handleChange}
        />
        <Input
          name="plateNumber"
          type="number"
          label={t("motorInsurance.renewalPolicyFlow.cprNoPage.plateNo")}
          value={formData?.plateNumber}
          error={errors?.plateNumber}
          handleChange={handleChange}
        />
      </div>
    </RenewMotorLayout>
  );
};

export default CprPlateNumberPage;
